import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as WebFont from 'webfontloader';
import {DasModule} from './app/das.module';
import {environment} from './environments/environment';

WebFont.load({
  google: {
    families: ['Material Icons']
  },
  active: bootstrapDas,
  inactive: bootstrapDas
});

function bootstrapDas(): void {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(DasModule)
    .catch(err => console.error(err));
}
